export default __webpack_public_path__ + "static/media/construction.55b13834.png";